//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('projectProcesses', {
//        templateUrl: 'views/components/views/projectProcesses/projectProcesses.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: [
//            '$stateParams',
//            'stateService',
//            'utilityService',
//            'projectProcessesService',
//            function ($stateParams, stateService, utilityService, projectProcessesService) {

//                // #region VARIABLES & DEFINITIONS

//                const vm = this;

//                vm.model = {
//                    setting: {},
//                    itemsListPosts: [],
//                };

//                // #endregion VARIABLES & DEFINITIONS

//                // #region LOAD PROCEDURE CALL

//                async function loadSetting() {
//                    vm.model.setting = (await projectProcessesService.getSetting({ project_keyno: $stateParams.project_keyno }))[0];
//                }

//                async function loadPosts() {
//                    if (utilityService.validateParmsValue(vm.model.setting.project_keyno) !== true) return;

//                    return vm.model.itemsListPosts = await projectProcessesService.listPosts({ project_keyno: vm.model.setting.project_keyno });
//                }

//                // #endregion LOAD PROCEDURE CALL

//                // #region MULTI DIRECTION BUTTON FUNCTIONS

//                vm.goToFunc = function (state, e) {
//                    function go(parms) {
//                        if (e?.ctrlKey) {
//                            stateService.newTab(state, parms);
//                        } else {
//                            stateService.go(state, parms);
//                        }
//                    }

//                    switch (state) {
//                        case 'projectprocess':
//                            go({
//                                project_keyno: vm.model.setting.project_keyno,
//                                projectprosess_keyno: '0',
//                                projectprosess_keyno_belongto: '0',
//                            });
//                            break;
//                        default:
//                            break;
//                    }
//                };

//                // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//                // #region ON INIT FUNCTION

//                vm.$onInit = async function () {
//                    await loadSetting();
//                    loadPosts();
//                }

//                // #endregion ON INIT FUNCTION

//            },
//        ],
//    });
//})();
